import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useSimpleHqAccess } from './useSimpleHqAccess'
import { SimpleHqLayout } from './SimpleHqLayout'

export function SimpleHqGuard() {
  const { user, passwordRecoveryPending } = useAuth()
  const { loading, isMember } = useSimpleHqAccess()
  const location = useLocation()

  if (passwordRecoveryPending) {
    return <Navigate to="/?view=landing" replace />
  }

  if (!user) {
    return (
      <Navigate
        to="/?view=landing"
        state={{ from: location, simpleHqAccessDenied: true }}
        replace
      />
    )
  }

  if (loading) {
    return (
      <div className="hq-app min-h-screen flex items-center justify-center">
        <i className="fa-solid fa-spinner fa-spin text-3xl text-[var(--hq-muted)]" aria-hidden />
        <span className="sr-only">Loading Simple HQ…</span>
      </div>
    )
  }

  if (!isMember) {
    return (
      <Navigate
        to="/?view=landing"
        state={{ from: location, simpleHqAccessDenied: true }}
        replace
      />
    )
  }

  return <SimpleHqLayout />
}
